import { useTranslation } from 'react-i18next';

export default function RegisterHero() {
  const { t } = useTranslation('register');

  return (
    <section className="relative min-h-[360px] md:min-h-[420px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20golden%20stage%20lighting%20with%20musical%20instruments%20silhouettes%2C%20professional%20concert%20atmosphere%20with%20amber%20and%20gold%20tones%2C%20blurred%20bokeh%20background%2C%20elegant%20and%20sophisticated%20mood%2C%20artistic%20photography%20style&width=1600&height=600&seq=register-hero&orientation=landscape"
          alt="Live music"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
      </div>
      <div className="relative z-10 text-center px-6 max-w-3xl">
        <span className="inline-block text-xs md:text-sm font-semibold text-amber-400 uppercase tracking-widest mb-4">
          {t('heroLabel')}
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          {t('heroTitle')}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          {t('heroDescription')}
        </p>
      </div>
    </section>
  );
}